import { MODULE_CONFIG } from "../../config/setup"

const states = {
  campaigns_details: {
    contacts: [],
    campaigns: [],
    total_campaigns: 0,
    current_page: 1,
    page_size: MODULE_CONFIG.CAMPAIGNS.CAMPAIGNS_PER_PAGE_TABLE_DATA,
    loading: false,
    load_error: false,

    // campaign details states
    campaign_about: {},
    records: [],
    campaign: {},
    current_campaign_page: 1,
    page_size_campaign:
      MODULE_CONFIG.CAMPAIGNS.CAMPAIGNS_RECORDS_PER_PAGE_TABLE_DATA,
    pollingIds: [],
  },
}

export default states
